export const IDD_COMMON_DOC_TYPE = 'b193a126-9219-4c81-b070-2abfaf7a3442';
export const GDPR_COMMON_DOC_TYPE = 'f4ebe08d-8c3a-4e09-9177-f52a3cc29a99';
